import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { styles } from '@ui/components/TanstackTable';
import { selectSnapOperation } from '@ui/features/quote-builder/state/selectors/snap-operation';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuoteLineContext } from '../../QuoteLineProvider';
import { MaterialInfo } from './MaterialInfo';
import { RequirementCell } from './RequirementCell';

const headers = [
  'Piece No.',
  'Quantity',
  'Quantity Per',
  'Fixed Quantity',
  'Fixed Cost',
  'Unit Material Cost',
  'Unit Labor Cost',
  'Unit Burden Cost',
  'Unit Service Cost',
];

export type RequirementsRowProps = {
  snapOperationUuid: string;
};

export function RequirementsRow({ snapOperationUuid }: RequirementsRowProps) {
  const { quoteLineUuid } = useQuoteLineContext();
  const { snapRequirementUuids, snapRequirements } = useSelector((state) =>
    selectSnapOperation(state, quoteLineUuid, snapOperationUuid),
  );

  return (
    <Flex direction="column" gap={2} alignItems="flex-start">
      {snapRequirementUuids.map((requirementUuid) => {
        const requirement = snapRequirements[requirementUuid];

        return (
          <Box key={requirementUuid}>
            <MaterialInfo
              id={requirement.part?.partId ?? ''}
              description={requirement.part?.description ?? ''}
            />

            <TableContainer width="100%">
              <Table
                width="100%"
                sx={{ ...styles, marginTop: '0' }}
                mb={0}
                size="sm"
              >
                <Thead>
                  <Tr>
                    {headers.map((header) => (
                      <Th key={header}>{header}</Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>{requirement.pieceNo}</Td>

                    <Td>{requirement.calcQty.toString()}</Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="qtyPer"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="fixedQty"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="fixedCost"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="unitMaterialCost"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="unitLaborCost"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="unitBurdenCost"
                      />
                    </Td>

                    <Td>
                      <RequirementCell
                        quoteLineUuid={quoteLineUuid}
                        snapOperationUuid={snapOperationUuid}
                        snapRequirementUuid={requirement.uuid}
                        field="unitServiceCost"
                      />
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        );
      })}
    </Flex>
  );
}
